exports.en = {
  UNIFORM_DETAIL: {
    INVALID_POBOCKY: 'Please choose.',
    POBOCKY_PLACEHOLDER: 'Please choose...',
    POBOCKY_NO_RESULTS: 'No results found.'
  }
}
